import { useMutation } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useDeleteFile = () => {
    return useMutation({
        mutationFn: async (fileId: string) => {
            return await salesApiService.aiAgent.knowledgeBase.deleteFile(fileId);
        },
    });
};
